import type { DocumentNode } from 'graphql';

export const getOperationNameFromDocumentNode = (doc: DocumentNode): string => {
  const definition = doc?.definitions?.find(
    (q) => q.kind === 'OperationDefinition'
  );
  return definition?.name?.value || 'unknown_operation';
};
